import { useNavigate } from 'react-router-dom'
import { Trans } from '@lingui/macro'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart'

type DoneStepProps = { patientLabel?: string; waitingRoomName?: string; consultationId?: string; onRestart: () => void }

/** Confirmation once the patient is queued: start the consultation (vital signs…) or welcome the next patient. */
export function DoneStep({ patientLabel, waitingRoomName, consultationId, onRestart }: DoneStepProps) {
  const navigate = useNavigate()

  return (
    <Stack spacing={3}>
      <Alert severity="success" variant="filled">
        <Trans>{patientLabel} is in the waiting room “{waitingRoomName}”.</Trans>
      </Alert>
      {consultationId && (
        <Button variant="contained" size="large" startIcon={<MonitorHeartIcon />} onClick={() => navigate(`/consultations/${consultationId}/live`)} autoFocus>
          <Trans>Start the consultation (vital signs, devices…)</Trans>
        </Button>
      )}
      <Button variant={consultationId ? 'outlined' : 'contained'} size="large" onClick={onRestart}>
        <Trans>Welcome another patient</Trans>
      </Button>
    </Stack>
  )
}
